module.exports = __webpack_public_path__ + "img/menu-hair-5.a05b794e.jpg";